module.exports = __webpack_public_path__ + "favicon-196x196.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon-196x196.png
// module id = 147
// module chunks = 0